module.exports = __webpack_public_path__ + "img/gplay.ba5ed3c7.png";